export default __webpack_public_path__ + "static/media/pink-unfollow.d3c29c76.svg";